/**
 * Input a UN DITO. Premuto ovunque = held. Registra i toggle nell'InputRecorder
 * con il tempo di SIM corrente (non wall-clock) così il replay è deterministico.
 * Su desktop la barra spaziatrice fa da dito, per il playtest.
 */

export interface InputSource {
  isDown(): boolean;
  /** callback opzionale ad ogni cambio di stato (per registrare i toggle). */
  onChange?: (down: boolean) => void;
}

export class PointerInput implements InputSource {
  private down = false;
  onChange?: (down: boolean) => void;
  private readonly detach: () => void;

  constructor(target: HTMLElement) {
    const set = (v: boolean, e?: Event) => {
      if (e) e.preventDefault();
      if (v === this.down) return;
      this.down = v;
      this.onChange?.(v);
    };

    const onDown = (e: PointerEvent) => set(true, e);
    const onUp = (e: PointerEvent) => set(false, e);
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.code === 'Space' && !e.repeat) set(true, e);
    };
    const onKeyUp = (e: KeyboardEvent) => {
      if (e.code === 'Space') set(false, e);
    };
    const onBlur = () => set(false);

    target.addEventListener('pointerdown', onDown);
    window.addEventListener('pointerup', onUp);
    window.addEventListener('pointercancel', onUp);
    window.addEventListener('keydown', onKeyDown);
    window.addEventListener('keyup', onKeyUp);
    window.addEventListener('blur', onBlur);

    this.detach = () => {
      target.removeEventListener('pointerdown', onDown);
      window.removeEventListener('pointerup', onUp);
      window.removeEventListener('pointercancel', onUp);
      window.removeEventListener('keydown', onKeyDown);
      window.removeEventListener('keyup', onKeyUp);
      window.removeEventListener('blur', onBlur);
    };
  }

  isDown(): boolean {
    return this.down;
  }

  dispose(): void {
    this.detach();
  }
}
